'use strict';

import React, { Component } from 'react';
import Layout from 'Layouts/Front';
import Logo from 'Pure/Logo';
const {
  app
} = window;
export default class MaintenancePage extends Component {
  render() {
    const component = this,
      props = this.props;
    let output = /*#__PURE__*/React.createElement(Layout, {
      history: props.history,
      page_title: "Maintenance",
      "hide-footer": true
    }, /*#__PURE__*/React.createElement("div", {
      className: "u-full-width"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: 600,
        maxWidth: '100%',
        margin: 'auto',
        textAlign: 'center',
        marginTop: 110
      }
    }, /*#__PURE__*/React.createElement(Logo, {
      style: {
        display: 'block',
        margin: 'auto'
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "u-margin-top-20",
      style: {
        color: '#0D3768',
        fontSize: 20
      }
    }, "Le site est actuellement en maintenance, nous reviendrons tr\xE8s bient\xF4t."))));
    return output;
  }
}
